import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import pubnub from '../../pubnub';
import { Home, Nav } from '../../components';
import { Login, Logout, Main, Signup } from '../';

const App = props => {
  const { currentUser, location } = props;
  const arr = location.pathname.split('/').filter(item => item !== '');
  const active = arr.length < 1 ? 'home' : arr[0];
  const isLoggedIn = currentUser !== null && currentUser.id !== undefined;
  if (isLoggedIn) {
    pubnub.setUUID(currentUser.id);
  }
  return (
    <div>
      <Nav isLoggedIn={isLoggedIn} activeItem={active} />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/signup" component={Signup} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/logout" component={Logout} />
        <Route component={Main} />
      </Switch>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser,
  };
}

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.jsx